"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnServSt = void 0;
const base_1 = require("./base");
/**
 * Sailthru
 */
class AnServSt extends base_1.AnServBase {
    static isLoaded() {
        return ((window.Sailthru !== undefined) &&
            (window.Sailthru.init !== undefined));
    }
    static sendInit(pixelId, userId, email, coupon) {
        const initProps = {
            customerId: pixelId,
            isCustom: true,
            autoTrackPageview: false
        };
        Sailthru.init(initProps);
        this.logEvent({
            cmd: "init",
            initProps: initProps
        });
        return true;
    }
    static sendIdentify(pixelId, userId, email) {
        return true;
    }
    static sendPage(pixelId, tags = null) {
        const opts = {
            url: location.href
        };
        if (tags !== null) {
            opts.tags = tags;
        }
        Sailthru.track("pageview", opts);
        this.logEvent({
            cmd: "track",
            eventName: "pageview",
            opts: opts
        });
        return true;
    }
    static sendAddToCart(pixelId, email, productUrl, productName, 
    // Specified in cents
    price) {
        const baseOpts = {
            items: [
                {
                    url: productUrl,
                    qty: 1,
                    title: productName,
                    price
                }
            ]
        };
        const eventOpts = Object.assign({ email }, baseOpts);
        const logOpts = Object.assign({ email: "HIDDEN" }, baseOpts);
        Sailthru.integration("addToCart", eventOpts);
        this.logEvent({
            cmd: "integration",
            eventName: "addToCart",
            opts: logOpts,
        });
        return true;
    }
    static sendPurchase(pixelId, email, productUrl, productName, 
    // Specified in cents
    price) {
        const baseOpts = {
            items: [
                {
                    url: productUrl,
                    qty: 1,
                    title: productName,
                    price
                }
            ]
        };
        const eventOpts = Object.assign({ email }, baseOpts);
        const logOpts = Object.assign({ email: "HIDDEN" }, baseOpts);
        Sailthru.integration("purchase", eventOpts);
        this.logEvent({
            cmd: "integration",
            eventName: "addToCart",
            opts: logOpts,
        });
        return true;
    }
}
exports.AnServSt = AnServSt;
AnServSt.serviceName = "Sailthru";
